import type { FC, SVGProps } from "react"

import type { BoxProps, IconProps } from "@chakra-ui/react"
import { Box, Icon, useBreakpointValue } from "@chakra-ui/react"

type SuplifulLogoProps = BoxProps & {
  variant?: "dark" | "light" | "default"
  height?: number
  narrow?: boolean
  iconProps?: IconProps
}

enum ClassNames {
  LOGO_ICON = "logo-icon",
  LOGO_ICON_NEGATIVE = "logo-icon-negative",
  LOGO_TEXT = "logo-text",
}

const Logo = (props: SVGProps<any>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1068.78 272.72"
      {...props}
    >
      <g>
        <g>
          <path
            className={ClassNames.LOGO_ICON}
            d="M208.3 101.07A104.18 104.18 0 00102.69 0C46.09.8.1 47.37 0 104a103.66 103.66 0 0018.76 59.85 3 3 0 01-2.45 4.71H3.05a3 3 0 00-3 3.11 104.17 104.17 0 00105.61 101.04c56.6-.79 102.59-47.36 102.69-104a103.67 103.67 0 00-18.77-59.85 3 3 0 012.46-4.72h13.26a3 3 0 003-3.07z"
          />
          <path
            className={ClassNames.LOGO_ICON_NEGATIVE}
            d="M56.54 133.44l64-64a3 3 0 015.12 2.13v59.23a3 3 0 003 3h24a3 3 0 012.12 5.12l-64 64a3 3 0 01-5.12-2.12v-59.24a3 3 0 00-3-3h-24a3 3 0 01-2.12-5.12z"
          />
          <path
            className={ClassNames.LOGO_TEXT}
            d="M352.05 116.15c6.29 1.83 12.06 2.88 19.14 5 22.55 6.85 33.57 17.85 33.57 43.25 0 28.58-23.61 43.53-51.14 43.53-37.2 0-49.83-21-50.12-44.18a3 3 0 013-3h27.7a3 3 0 013 2.76c.64 8.79 4.59 16.12 16.95 16.12 9.18 0 16.53-4.46 16.53-12.59s-4.2-11.8-13.9-14.42c-7.61-2.1-13.64-3.41-21.24-6.3-19.41-7.08-29.11-20.19-29.11-41.43 0-23.6 19.93-40.91 48-40.91 28.55 0 45.91 13.88 47.36 41.18a3 3 0 01-3 3.14h-26.37a3 3 0 01-3-2.62c-1-9.15-6-14.42-15.83-14.42-8.39 0-13.9 4.72-13.9 11.8.03 6.79 3.97 10.73 12.36 13.09zM455.91 153.91c0 13.64 5.51 22.29 18.1 22.29s19.4-9.18 19.4-22.55V68.8a3 3 0 013-3h29.14a3 3 0 013 3v134.29a3 3 0 01-3 3h-28.88a3 3 0 01-3-3v-7.49c-3.67 4.72-12.85 12.07-29.37 12.07-31.2 0-43.53-21-43.53-49.57V68.8a3 3 0 013-3h29.14a3 3 0 013 3zM585.29 233.43l-29.14 24.2a3 3 0 01-4.92-2.31V68.8a3 3 0 013-3h27.31a3 3 0 013 3v10.37c7.08-7.08 20.71-15.73 43-15.73 42.48 0 70.28 29.89 70.28 72.11 0 40.65-27.27 72.9-71.85 72.9-18.62 0-32.52-7.6-39.6-13.63v36.3a3 3 0 01-1.08 2.31zm38.84-56.18c23.87 0 38.55-17.31 38.55-41.17s-15.47-41.44-38.81-41.44c-23.86 0-38.55 17.57-38.55 41.44s15.47 41.17 38.81 41.17zM746.58 206.09h-29.14a3 3 0 01-3-3V45.41a3.89 3.89 0 011.41-3l28.81-23.94a3 3 0 014.92 2.31v182.3a3 3 0 01-3 3.01zM768.85 36.17a21 21 0 1142 0 21 21 0 01-42 0zm35.55 169.92h-29.14a3 3 0 01-3-3V68.8a3 3 0 013-3h29.14a3 3 0 013 3v134.29a3 3 0 01-3 3zM870.36 65.8h17.71a3 3 0 013 3v23.63a3 3 0 01-3 3h-17.71v107.66a3 3 0 01-3 3h-29.14a3 3 0 01-3-3V95.43h-10.11a3 3 0 01-3-3V68.8a3 3 0 013-3h10.11v-6.29c0-27.54 11-45.37 44.58-45.37 1.38 0 5.15 0 8.39.11a3 3 0 012.88 3v23.52a3 3 0 01-3 3h-3.55c-11.8 0-14.16 7.61-14.16 16zM938.32 153.91c0 13.64 5.51 22.29 18.1 22.29s19.4-9.18 19.4-22.55V68.8a3 3 0 013-3H1008a3 3 0 013 3v134.29a3 3 0 01-3 3h-28.91a3 3 0 01-3-3v-7.49c-3.68 4.72-12.85 12.07-29.37 12.07-31.21 0-43.53-21-43.53-49.57V68.8a3 3 0 013-3h29.13a3 3 0 013 3zM1065.78 206.09h-29.14a3 3 0 01-3-3V45a3 3 0 011.09-2.31l29.14-24.2a3 3 0 014.91 2.31v182.3a3 3 0 01-3 2.99z"
          />
        </g>
      </g>
    </svg>
  )
}

export const SuplifulLogo: FC<SuplifulLogoProps> = ({
  variant = "default",
  height,
  narrow,
  iconProps,
  ...rest
}) => {
  const defaultHeight = useBreakpointValue({ base: 7, md: 8 })

  return (
    <Box
      sx={{
        [`.${ClassNames.LOGO_ICON}`]: {
          fill:
            variant === "light"
              ? "white"
              : variant === "dark"
                ? "black"
                : "main.700",
        },
        [`.${ClassNames.LOGO_ICON_NEGATIVE}`]: {
          fill: variant === "light" ? "neutrals.900" : "white",
        },
        [`.${ClassNames.LOGO_TEXT}`]: {
          fill: variant === "light" ? "white" : "black",
          display: narrow ? "none" : undefined,
        },
      }}
      lineHeight={0}
      {...rest}
    >
      <Icon
        as={Logo}
        h={height || defaultHeight}
        w="auto"
        viewBox={narrow ? "0 0 272.72 272.72" : "0 0 1068.78 272.72"}
        {...iconProps}
      />
    </Box>
  )
}
